import { Link } from "react-router-dom";
import { Mail, Building2, Scale } from "lucide-react";

export const CONTACT = { entity: "ChangeOS.co", jurisdiction: "New Zealand", email: "support@changeos.co" };

export function ContactBlock({ title = "Contact Information", intro = "For any questions or legal inquiries regarding these terms, please contact us at:", showForm = true, stacked = false }) {
  const rows = [
    { icon: Building2, label: "Entity", value: CONTACT.entity, testid: "contact-entity" },
    { icon: Scale, label: "Jurisdiction", value: CONTACT.jurisdiction, testid: "contact-jurisdiction" },
    { icon: Mail, label: "Email", value: <a href={`mailto:${CONTACT.email}`} className="text-accent-700 hover:underline font-semibold">{CONTACT.email}</a>, testid: "contact-email" },
  ];
  return (
    <section id="contact" aria-labelledby="contact-heading" className="pp-card p-6 sm:p-8 bg-muted" data-testid="contact-block">
      <h2 id="contact-heading" className="font-head text-lg md:text-xl font-extrabold">{title}</h2>
      {intro && <p className="text-sm text-subtle mt-2">{intro}</p>}
      <dl className={`mt-5 grid gap-4 ${stacked ? "" : "sm:grid-cols-3"}`}>
        {rows.map((r) => (
          <div key={r.label} className="flex items-start gap-3" data-testid={r.testid}>
            <div className="w-9 h-9 rounded-xl bg-ink text-on-dark flex items-center justify-center shrink-0" aria-hidden="true"><r.icon size={16} /></div>
            <div><dt className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{r.label}</dt><dd className="text-sm text-foreground mt-0.5">{r.value}</dd></div>
          </div>
        ))}
      </dl>
      {showForm && <p className="text-sm text-subtle mt-5">Prefer a form? <Link to="/contact" data-testid="contact-block-link" className="font-semibold text-foreground hover:text-accent-700 underline underline-offset-2">Send us a message</Link>.</p>}
    </section>
  );
}
